import { render } from "./Suspenser.vue?vue&type=template&id=6f5cb740&scoped=true"
import script from "./Suspenser.vue?vue&type=script&lang=js"
export * from "./Suspenser.vue?vue&type=script&lang=js"

import "./Suspenser.vue?vue&type=style&index=0&id=6f5cb740&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5cb740"]])

export default __exports__